var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClioLoading({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 20,
    height: 20,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#b7844d;#000000;#000000",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 19,
    width: 20,
    height: 20,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#b7844d;#000000;#000000",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.125s",
    calcMode: "discrete"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 19,
    width: 20,
    height: 20,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#b7844d;#000000;#000000",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.25s",
    calcMode: "discrete"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 40,
    width: 20,
    height: 20,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#b7844d;#000000;#000000",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.875s",
    calcMode: "discrete"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 40,
    width: 20,
    height: 20,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#b7844d;#000000;#000000",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.375s",
    calcMode: "discrete"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 61,
    width: 20,
    height: 20,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#b7844d;#000000;#000000",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.75s",
    calcMode: "discrete"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 61,
    width: 20,
    height: 20,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#b7844d;#000000;#000000",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.625s",
    calcMode: "discrete"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 61,
    width: 20,
    height: 20,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#b7844d;#000000;#000000",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.5s",
    calcMode: "discrete"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClioLoading);
export default __webpack_public_path__ + "static/media/clio-loading.316ea855cb3ee4a0448d9b4ede12be46.svg";
export { ForwardRef as ReactComponent };